var swiper = new Swiper('.swiper-container.swiper-sec', {
    navigation: {
      nextEl: '.swiper-button-next.swiper-sec',
      prevEl: '.swiper-button-prev.swiper-sec',
    },
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination.swiper-sec',
      type: 'bullets',
      clickable: true
    },
});

